import { apiFetch } from '@/lib/api';

export interface ClientDTO {
  id: string;
  name: string;
  contact_name?: string | null;
  contact_email?: string | null;
  contact_phone?: string | null;
  notes?: string | null;
}

export interface Paginated<T> {
  items: T[];
  pagination: { page: number; pageSize: number; totalItems: number; totalPages: number };
}

export class ClientsService {
  async list(page = 1, pageSize = 20): Promise<Paginated<ClientDTO>> {
    const res = await apiFetch(`/api/clients?page=${page}&pageSize=${pageSize}`);
    if (!res.ok) throw new Error('Failed to fetch clients');
    const data = await res.json();
    return data.data as Paginated<ClientDTO>;
  }

  async get(id: string): Promise<ClientDTO> {
    const res = await apiFetch(`/api/clients/${id}`);
    if (!res.ok) throw new Error('Failed to fetch client');
    const data = await res.json();
    return data.data as ClientDTO;
  }

  async create(input: ClientDTO): Promise<void> {
    const res = await apiFetch('/api/clients', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });
    if (!res.ok) throw new Error('Failed to create client');
  }

  async update(id: string, updates: Partial<ClientDTO>): Promise<void> {
    const res = await apiFetch(`/api/clients/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates),
    });
    if (!res.ok) throw new Error('Failed to update client');
  }

  async delete(id: string): Promise<void> {
    const res = await apiFetch(`/api/clients/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to delete client');
  }
}


